// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductCategories_RemoverInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/product_categories/remover
 *
 * Deletes a product category.
 */
import { registerContract } from './validate'

export interface ProductCategories_RemoverInput {
so_product_category_id: number
}

registerContract('ProductCategories_RemoverInput', {
  so_product_category_id: { type: 'number',  required: true },
})
